module.exports = __webpack_public_path__ + "static/media/devices.f0c9e8d9.jpg";